import { Factory } from 'fishery';
import { Stop } from '@trukt/types/Stop';
import { terminalFactory } from './terminalFactory';
import { contactFactory } from './contactFactory';
import { commodityFactory } from './commodityFactory';

export const stopFactory = Factory.define<Stop>(({ sequence }) => ({
  guid: sequence.toString(),
  stopType: 'pickup',
  sequence,
  status: 'Test Status',
  dateStarted: '2022-08-26T22:37:30.745Z',
  dateCompleted: '2022-08-26T22:37:30.745Z',
  dateScheduledStart: '2022-08-26T22:37:30.745Z',
  dateScheduledEnd: '2022-08-26T22:37:30.745Z',
  dateScheduledType: 'exactly',
  dateEstimatedStart: '2022-08-26T22:37:30.745Z',
  dateEstimatedEnd: '2022-08-26T22:37:30.745Z',
  dateRequestedType: 'estimated',
  dateRequestedStart: '2022-08-26T22:37:30.745Z',
  dateRequestedEnd: '2022-08-26T22:37:30.745Z',
  notes: 'Test Notes',
  primaryContact: contactFactory.build(),
  alternativeContact: contactFactory.build(),
  terminal: terminalFactory.build(),
  commodities: commodityFactory.buildList(1),
}));
